export const REGEX_INLINE_CODE = /(?:^|[^`])(`([^`]+)`)$/;
export const INLINE_CODE_NODE_NAME = 'code_inline';
